import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";
import { Colors } from "../style/theme";

export const NotFoundContainer = styled(Box)(({ theme }) => ({
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(1),
  height: "85vh",
  justifyContent: "center",
  position: "relative",
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(1),
  justifyContent: "center",
  position: "relative",
  zIndex: 0,
}));

export const SVGContainer = styled(Box)({
  color: Colors.secondaryText,
  position: "absolute",
  inset: 0,
  transform: "scale(1.75)",
  top: "50px",
  zIndex: 0,
  "@media (max-width:899px)": {
    transform: "scale(1)",
},
});

export const TextContent = styled(Box)({
  position: "relative",
  zIndex: 1,
  marginTop: "120px",
});

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  justifyContent: "center",
  marginTop: theme.spacing(3),
}));

export const BackButton = styled(Button)({
  color: Colors.primary,
  border: "1px solid " + Colors.primary,
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
});

export const HomeButton = styled(Button)(({ theme }) => ({
  backgroundColor: Colors.primary,
  "&:hover": {
    backgroundColor: `${Colors.primary}`,
  },
}));
